module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1200x2-25f652fd88d34668500c400bef94c6cf.webp";